import { ROLES_GESTAO_ORCAMENTARIA } from "./departamentosOrcamento";

// Premissas · Viagens: consolida o ticket médio por projeto (Custos Gerais por Projeto) e o
// ticket médio global/Backoffice (Despesas Gerais) numa única página — como todo role de
// ROLES_CUSTOS_GERAIS_PROJETO já está contido em ROLES_GESTAO_ORCAMENTARIA, a união é a própria.
// Espelha backend/config.py ROLES_PREMISSAS_VIAGEM — mantenha os dois em sincronia.
export const ROLES_PREMISSAS_VIAGEM = ROLES_GESTAO_ORCAMENTARIA;
